import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { apiError } from "../lib/api";
import Logo from "../components/Logo";
import GoogleButton from "../components/GoogleButton";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex gdf-hero-glow text-white p-12 flex-col justify-between">
        <Link to="/"><div className="bg-white/95 rounded-xl inline-block px-3 py-2"><Logo className="h-10" /></div></Link>
        <div>
          <h1 className="text-4xl font-head font-extrabold leading-tight">Welcome back to the community that always says <span className="gdf-gradient-text">YES</span>.</h1>
          <p className="mt-4 text-slate-300 max-w-md">Log in to manage your package, track your contributions, and request assistance.</p>
        </div>
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} Givers Driven Funds (Pty) Ltd</p>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#FAFAF9]">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Link to="/"><Logo className="h-10" /></Link></div>
          <h2 className="text-2xl font-head font-bold text-[#0A192F]">Log in to your account</h2>
          <p className="text-slate-500 text-sm mt-1">Members, agents and owner sign in here.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit" className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-full h-11">{loading ? "Signing in..." : "Log in"}</Button>
          </form>

          <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><div className="flex-1 h-px bg-slate-200" /> OR <div className="flex-1 h-px bg-slate-200" /></div>
          <GoogleButton label="Continue with Google" />

          <p className="mt-6 text-sm text-slate-500 text-center">
            Don't have an account? <Link to="/register" className="text-emerald-600 font-semibold" data-testid="login-to-register">Become a member</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
